import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { formattedStat, formatPriceUsd } from 'shared/src/utils/formatting'

import { MAIN_TITLE_STYLE, NOTES_BOLD_STYLE } from '../styles'

const useStyles = createUseStyles({
  singleStatContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  statValue: {
    ...MAIN_TITLE_STYLE,
    fontSize: 36,
    marginBottom: 20,
  },
  statDescription: {
    ...NOTES_BOLD_STYLE,
    color: '#90734F',
    opacity: 0.8,
  },
})

interface Props {
  statValue: number
  statDescription: string
  type: 'number' | 'dollar'
}

export const Stat: FC<Props> = flowMax(
  addDisplayName('Stat'),
  addProps(({ statValue, type }) => ({
    formattedValue:
      type === 'dollar' ? formatPriceUsd(statValue) : formattedStat(statValue),
  })),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ formattedValue, statDescription, classes }) => (
    <div className={classes.singleStatContainer}>
      <p className={classes.statValue}>{formattedValue}</p>
      <p className={classes.statDescription}>{statDescription}</p>
    </div>
  )
)
